import { createContext } from "react";

export const ContextPromo = createContext(null);